/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { faMobileAlt } from '@fortawesome/free-solid-svg-icons/faMobileAlt'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useIntl } from 'react-intl'
import FormField, {
  FormTextFieldProps
} from '../../../../client/js/components/form/fields/FormField'
import PhoneInput from '../inputs/PhoneInput'

function MobileField (props: FormTextFieldProps) {
  const { name = 'mobile', ...others } = props
  const intl = useIntl()
  return (
    <FormField
      autoComplete="tel"
      label={intl.formatMessage({
        id: 'mobile',
        defaultMessage: 'Mobile'
      })}
      name={name}
      mask="689.80000000"
      placeholder="689.80000000"
      render={PhoneInput}
      type="tel"
      leftSection={(
        <FontAwesomeIcon
          fixedWidth
          icon={faMobileAlt}
        />
      )}
      {...others}
    />
  )
}

export default MobileField
